import React from "react";

const SchoolNotFound = () => {

  return (
   <>
      <div className="h-screen flex items-center justify-center">
        <h1 className="text-xl font-semibold text-red-600">
          School not found for this domain.
        </h1>
      </div>
    </>
  );
};

export default SchoolNotFound;
